import React from "react";
import { Lock } from "lucide-react";
import { t } from "i18next";
import { Layout, SectionContent } from "@layouts/MainLayout";

const UnauthorizedPage: React.FC = () => {
  return (
    <Layout>
      <SectionContent>
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <Lock size={48} color="red" />
            </div>

            <h1 className="text-3xl font-semibold text-gray-700">
              {t("error.unauthorized")}
            </h1>

            <p className="mt-4 text-gray-600">
              {t("error.unauthorizedMessage")}
            </p>
          </div>
        </div>
      </SectionContent>
    </Layout>
  );
};

export default UnauthorizedPage;
